<template>
  <div class="navbar-top d-flex flex-1 flex-column">
    <navbar/>
    <div class="page-content">
      <sidebar/>

      <main class="content-wrapper" :class="routeName === 'import.invoices.create' ? 'overflow-visible' : ''">
        <router-view/>

        <footer-nav/>
      </main>
    </div>

    <update-notification/>
    <issue-notification/>

    <div id="og-sidebar-backdrop" v-once/>
  </div>
</template>

<script setup>
  import FooterNav from '@/layout/dashboard/footer';
  import UpdateNotification from '@/layout/dashboard/partials/update-notification';
  import IssueNotification from '@/layout/dashboard/partials/issue-notification';
  import Navbar from './navbar';
  import Sidebar from './sidebar';
  import { useRoute } from 'vue-router';
  import { computed } from 'vue';

  const route = useRoute();

  const routeName = computed(() => route.name);
</script>
